import React, { useContext, useMemo, useState } from "react";
import { ModalContext } from "components/ModalContext";
import { useHistory } from 'react-router-dom';
import { useDashboardState } from "components/DashboardContext";
import { findFoldersTreeObj } from "utils/helpers";
import { getNextLevel, addToFavorites, removeFromFavorites, addToRecent } from "utils/builder/IModelsTree";
import { format } from 'date-fns'
import classNames from "classnames";
import VersionsModal from "components/modals/VersionsModal";
import "./GridItem.scss";

import { ReactComponent as FolderIcon } from "static/icons/folder.svg";
import { ReactComponent as StarIcon } from "static/icons/star.svg";

import rvtImage from "static/images/fileTypes/rvt.png";
import nwImage from "static/images/fileTypes/nwc.png";
import ifcImage from "static/images/fileTypes/ifc.png";
import iwmImage from "static/images/fileTypes/iwm.png";
import dwgImage from "static/images/fileTypes/dwg.png";
import fbxImage from "static/images/fileTypes/fbx.png";
import unfamiliarImage from "static/images/fileTypes/unfamiliar.png";
import ChooseCategory from "../../modals/ChooseCategory";
import { setCurrentProjectAction } from "store/actions/currentProject";
import { useDispatch } from "react-redux";

// TODO: the bug is here?
const GridItem = ({
  item: {
    children,
    id,
    idToOpen,
    isFavorite,
    lastUpdate,
    pictureUrl,
    lastVersion,
    size,
    text,
    type,
    updatedBy,
    lastOpened,
  },
  titleWidth,
  isBlock,
}) => {
  const history = useHistory();

  const [selectedCategory, setSelectedCategory] = useState(null);

  const dispatch = useDispatch()
  
  const {
    activeFolder,
    foldersTree,
    favourites,
    recent,
    setFoldersTree,
    setActiveFolder,
    setActiveProject,
    setIsFolderLoading,
    setFavourites,
    setRecent,
  } = useDashboardState();

  const { handleModal } = useContext(ModalContext);

  const handleCloseModal = () => {
    handleModal(null, true);
  };

  const getFileExtension = path => {
    const pathArr = path?.split('.');

    return pathArr?.[pathArr?.length - 1];
  };

  const getFileIconPath = path => {
    const ext = getFileExtension(path);

    switch(ext) {
      case 'rvt':
        return rvtImage;
      case 'nwc':
      case 'nwd':
        return nwImage;
      case 'ifc':
        return ifcImage;
      case 'iwm':
        return iwmImage;
      case 'dwg':
      case 'dwf':
      case 'dwfx':
      case 'dwt':
        return dwgImage;
      case 'fbx':
        return fbxImage;
      default:
        return unfamiliarImage;
    }
  };

  const fileIconPath = useMemo(() => {
    return getFileIconPath(text);
  }, [text]);

  const loadModel = () => {
    const item = {
      children,
      id,
      idToOpen,
      isFavorite,
      lastUpdate,
      pictureUrl,
      lastVersion,
      size,
      text,
      type,
      updatedBy,
      lastOpened,
    };

    if (type === 'items') {
      addToRecent(item);
      setActiveProject(item);

      history.push({
        pathname: `/project/${idToOpen}`,
        state: { project: item }
      });
    } else if (type === 'versions') {
      addToRecent(item);
      setActiveProject(item);

      history.push({
        pathname: `/project/${idToOpen}`,
        state: { project: item }
      });
    }
  };

  const handleClick = () => {
    const item = {
      children,
      id,
      idToOpen,
      isFavorite,
      lastUpdate,
      pictureUrl,
      lastVersion,
      size,
      text,
      type,
      updatedBy,
      lastOpened,
    };

    if (type === 'folders') {
      const requestedObj = findFoldersTreeObj(id, foldersTree);

      if (requestedObj?.childrenArr) {
        setActiveFolder(id);
      } else {
        setIsFolderLoading(true);

        getNextLevel(id)
          .then(res => {
            if (requestedObj) {
              if (!requestedObj?.childrenArr?.length) {
                requestedObj.childrenArr = res;
              }
            }

            setFoldersTree(foldersTree);
          })
          .then(() => {
            setActiveFolder(id);
          })
          .finally(() => {
            setIsFolderLoading(false);
          });
      }
    } else if (type === 'items') {
        dispatch(setCurrentProjectAction(item))
        handleModal(<ChooseCategory loadModel={loadModel}/>);
    }
  };

  const handleFavouriteClick = (e) => {
    e.stopPropagation();

    const item = {
      children,
      id,
      idToOpen,
      isFavorite,
      lastUpdate,
      pictureUrl,
      lastVersion,
      size,
      text,
      type,
      updatedBy,
      lastOpened,
    };

    const foldersTreeCopy = JSON.parse(JSON.stringify(foldersTree));
    const requestedObj = findFoldersTreeObj(id, foldersTreeCopy);

    const setCurrentItemFavouriteStatusInData = (id, data, status) => {
      const currentItem = findFoldersTreeObj(id, data);
      currentItem.isFavorite = status;

      return data;
    };

    if (isFavorite) {
      item.isFavorite = false;

      if (requestedObj) {
        requestedObj.isFavorite = false;
      }

      if (activeFolder === 'favourites') {
        const updatedFavourites = setCurrentItemFavouriteStatusInData(id, favourites, false);

        setFavourites(updatedFavourites);
      }

      if (activeFolder === 'recent') {
        const updatedRecent = setCurrentItemFavouriteStatusInData(id, recent, false);

        setRecent(updatedRecent);
      }

      removeFromFavorites(item);
    } else {
      item.isFavorite = true;

      if (requestedObj) {
        requestedObj.isFavorite = true;
      }

      if (activeFolder === 'favourites') {
        const updatedFavourites = setCurrentItemFavouriteStatusInData(id, favourites, true);
        setFavourites(updatedFavourites);
      }

      if (activeFolder === 'recent') {
        const updatedRecent = setCurrentItemFavouriteStatusInData(id, recent, true);

        setRecent(updatedRecent);
      }

      addToFavorites(item);
    }

    setFoldersTree(foldersTreeCopy);
  }

  const handleClickVersions = (e) => {
    e.stopPropagation();

    const item = {
      children,
      id,
      idToOpen,
      isFavorite,
      lastUpdate,
      pictureUrl,
      lastVersion,
      size,
      text,
      type,
      updatedBy,
      lastOpened,
    };

    getNextLevel(id)
      .then(res => {
        const requestedObj = findFoldersTreeObj(id, foldersTree);

        if (requestedObj) {
          if (!requestedObj?.childrenArr?.length) {
            requestedObj.childrenArr = res;
          }

          setFoldersTree(foldersTree);
        }

        return res;
      })
      .then(res => {
        dispatch(setCurrentProjectAction(item))
        handleModal(
          <VersionsModal
            closeModal={handleCloseModal}
            versions={res}
            parentItem={item}
            title={text}
            fileIconPath={fileIconPath}
          />
        );
      })
  };

  return (
    <div
      className={classNames({
        "grid-item": true,
        "grid-item__block": isBlock,
      })}
      onClick={handleClick}
    >
      <div className="grid-item__container">
        <div
          className="grid-item__star"
          onClick={handleFavouriteClick}
        >
          {type !== 'folders' &&
            <StarIcon
              className={classNames({
                "grid-item__star_icon": true,
                "grid-item__star_icon--active": !!isFavorite,
              })}
            />
          }
        </div>

        {type === 'folders' &&
          <FolderIcon
            className="grid-item__folder"
          />
        }

        {(type === 'items' || type === 'versions') &&
          <div
            className="grid-item__file"
            style={{
              backgroundImage: `url('${fileIconPath}')`,
            }}
          />
        }

        <p
          className={classNames({
            "grid-item__title": true,
            "grid-item__title--fullwidth": type === 'folders',
          })}
          style={!isBlock ? { maxWidth: titleWidth } : null}
          title={text}
        >
          {text}
        </p>

        <div
          className="grid-item__version_container"
        >
          {type !== 'folders' && lastVersion &&
            <p
              className={classNames({
                "grid-item__version": true,
                "grid-item__version--canhovered": type === 'items',
              })}
              onClick={handleClickVersions}
            >
              {lastVersion}
            </p>
          }
        </div>

        <p className="grid-item__size">
          {!isBlock && type !== 'folders' &&
            `${Math.floor(size / 1024 / 1024)} MB`
          }
        </p>

        {!isBlock &&
          <p className="grid-item__lastupd">
            {format(new Date(lastUpdate * 1000), 'MM.dd.yyyy; HH:mm')}
          </p>
        }

        {!isBlock &&
          <p className="grid-item__updby">
            {updatedBy}
          </p>
        }

        {!isBlock && activeFolder === 'recent' &&
          <p className="grid-item__lastopened">
            {lastOpened ? format(new Date(lastOpened * 1000), 'MM.dd.yyyy; HH:mm') : '-'}
          </p>
        }
      </div>
    </div>
  );
};

export default GridItem;
